import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { InputField } from "../../../../../../../CommonComponents/commonStyles";
import { fetchZipCodeData, flushZipCode, resetAllZipFields } from '../../../../../../../CommonComponents/Zipcode/actions';
import ToJS from '../../../../../../Grants/Pages/GrantsDashboard/components/HOC/toJS';
import { updateZipCodeValues } from "../../../actions";
import { getZipCodeDetails } from '../../../../../../../utils/commonUtil';

export class Zipcode extends Component {
  componentWillUnmount() {
    this.props.flushZipCode();
  }

  showError = () => {
    this.props.updateZipCodeVal(this.props.path, true);
    return false;
  };

  getZipCodeStatus = (zipCode, zipTitle) => {
    if (zipCode.length === 5) {
      return zipCode.indexOf('-') === -1 ? true : this.showError();
    }
    if (zipCode.length === 10) {
      return zipCode.indexOf('-') === 5 && zipCode.split('-').length === 2
        ? true
        : this.showError();
    } else {
      return this.props.isUS ? this.showError(zipTitle) : false;
    }
  };

  checkZipCodeOnBlur = (e) => {
    this.props.onBlur(e);
  };

  getZipCode = (e) => {
    const zipCode = e.target.value;
    const zipTitle = e.target.title;
    if (this.props.isUS && this.getZipCodeStatus(zipCode, zipTitle)) {     
      getZipCodeDetails(zipCode)
        .then((response) => {
          this.props.getZipCode(zipTitle, response);
        })
        .catch((err) => console.log(err));
    }
    this.props.onChange(e);
  };

  render() {
    const {
      name,
      title,
      maxLength,
      placeholder,
      id,
      onBlur,
      value,
      className,
      path
    } = this.props;
    return (
      <InputField
        data-test='input-field'
        id={id}
        aria-labelledby={this.props.property}
        role="textbox"
        name={name}
        className={className ? className : 'macInputFieldPadding'}
        title={title}
        onChange={this.getZipCode}
        placeholder={placeholder}
        onBlur={(e) => this.checkZipCodeOnBlur(e)}
        maxLength={maxLength ? maxLength : null}
        value={value}
      />
    );
  }
}

Zipcode.propTypes = {
  getZipCode: PropTypes.func,
  flushZipCode: PropTypes.func,
  resetAllZipFields: PropTypes.func,
  updateZipCodeVal: PropTypes.func,

}

const mapStateToProps = (state) => ({
  zipCode: state.getIn(['zipCode', 'zipCodes']),
});

export const mapDispatchToProps = (dispatch) => ({
  getZipCode: (zipTitle, data) => dispatch(fetchZipCodeData(zipTitle, data)),
  flushZipCode: () => dispatch(flushZipCode()),
  resetAllZipFields: (zipTitle) => dispatch(resetAllZipFields(zipTitle)),
  updateZipCodeVal: (path, clear) => dispatch(updateZipCodeValues({path, clear}))
});

export default ToJS(connect(mapStateToProps, mapDispatchToProps)(Zipcode));
